import React from "react";

export default function VerticalImageList({ items }) {
  const images = items.map((item, i) => {
    return (
      // REFACTOR: fix this selectively disabled rule next time when working on
      //           this part
      /* eslint-disable jsx-a11y/anchor-has-content */
      <a
        key={i}
        href={item.url}
        className="cover-item"
        style={{ backgroundImage: `url(${item.image})` }}
      />
      /* eslint-enable jsx-a11y/anchor-has-content */
    );
  });

  return <div className="cover-container">{images}</div>;
}
